import { CookieConsent } from "./CookieConsent"
import { NavMenu } from "./NavMenu"
import { SiteFooter } from "./SiteFooter"

export const Layout = ({ children }) => (
  <>
    <CookieConsent />
    <a href="#main-content" className="sr-only skip-link">
      Skip to main content
    </a>
    <NavMenu />
    <main id="main-content">{children}</main>
    <SiteFooter />
  </>
)
